// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__3fs2A","title":"style_title__v5Ocp","desc":"style_desc__2Mh2Q","contact":"style_contact__230yn","tel":"style_tel__3vPH7","mail":"style_mail__kRGjo"};